
import React from 'react';
import { ExternalLink, Globe, ShoppingCart, Zap } from 'lucide-react';

const NewProjectsSection = () => {
  const projects = [
    {
      title: "TapG.gr",
      color: "bg-red-600",
      icon: <Zap className="w-8 h-8 text-white" />,
      description: "NFC προϊόντα για Google αξιολογήσεις & social media follow.",
      details: "Smart λύσεις για φυσικές επιχειρήσεις που θέλουν περισσότερες αξιολογήσεις και σύνδεση με το κοινό τους.",
      logo: "/lovable-uploads/67599810-d55c-4969-b20c-e4125ec67b96.png",
      url: "https://tapg.gr",
      features: ["NFC Technology", "Google Reviews", "Social Media Integration"]
    },
    {
      title: "UpPlead.gr",
      color: "bg-blue-600",
      icon: <ShoppingCart className="w-8 h-8 text-white" />,
      description: "Κατασκευή Shopify eshop για επαγγελματίες.",
      details: "Λειτουργικά eShops με SEO, email sequences και υποστήριξη.",
      logo: "/lovable-uploads/60ba8848-57d9-4281-80e0-d87eb73a4cde.png",
      url: "https://upplead.gr",
      features: ["Shopify Development", "SEO Optimization", "Email Automation"]
    },
    {
      title: "RentMySite.gr",
      color: "bg-yellow-600",
      icon: <Globe className="w-8 h-8 text-white" />,
      description: "Ενοικίαση ΑΙ-powered ιστοσελίδας σε 24 ώρες.",
      details: "Ιδανικό για κάθε επαγγελματία που χρειάζεται παρουσία online χωρίς υψηλό αρχικό κόστος. Από 26€/μήνα με hosting, σχεδίαση & επικοινωνιακή φόρμα.",
      logo: "/lovable-uploads/c98b5412-10f8-4e23-8348-b8824e4887d3.png",
      url: "https://rentmysite.gr",
      features: ["AI-Powered", "24h Delivery", "All-Inclusive"]
    }
  ];

  return (
    <section className="py-32 bg-black">
      <div className="container mx-auto px-6 md:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-20">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
              Οι Πλατφόρμες του
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
              Κάθε project είναι ένα λειτουργικό brand που δημιουργήθηκε από το μηδέν και αναπτύσσεται καθημερινά
            </p>
          </div>
          
          <div className="grid lg:grid-cols-3 gap-10">
            {projects.map((project, index) => (
              <div 
                key={index}
                className="group relative bg-gradient-to-br from-dark-300 to-dark-400 rounded-2xl p-8 hover:from-dark-400 hover:to-dark-500 transition-all duration-500 hover:scale-105 hover:shadow-2xl animate-fade-in-up border border-gray-800 hover:border-gray-600"
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                {/* Background Pattern */}
                <div className="absolute inset-0 bg-gradient-to-br from-transparent via-transparent to-gray-900/20 rounded-2xl"></div>
                
                {/* Header */}
                <div className="relative z-10 flex items-center justify-center mb-8">
                  <div className={`w-20 h-20 ${project.color} rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                    <img 
                      src={project.logo} 
                      alt={`${project.title} Logo`} 
                      className="w-12 h-12 object-contain"
                    />
                  </div>
                  
                  <a 
                    href={project.url} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="absolute top-0 right-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-gray-400 hover:text-white"
                  >
                    <ExternalLink className="w-6 h-6" />
                  </a>
                </div>
                
                {/* Content */}
                <div className="relative z-10">
                  <h3 className="text-2xl font-bold text-white mb-4">
                    {project.title}
                  </h3>
                  
                  <p className="text-gray-300 mb-6 leading-relaxed">
                    {project.description}
                  </p>
                  
                  {/* Features */}
                  <div className="mb-6">
                    <div className="flex flex-wrap gap-2">
                      {project.features.map((feature, featureIndex) => (
                        <span 
                          key={featureIndex}
                          className="text-xs px-3 py-1 bg-gray-800 text-gray-300 rounded-full border border-gray-700"
                        >
                          {feature}
                        </span>
                      ))}
                    </div>
                  </div>
                  
                  {/* Details on hover */}
                  <div className="opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-y-4 group-hover:translate-y-0">
                    <p className="text-gray-400 text-sm mb-6 leading-relaxed">
                      {project.details}
                    </p>
                    
                    <a 
                      href={project.url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="inline-flex items-center space-x-2 text-brand hover:text-brand-hover transition-colors font-medium"
                    >
                      <span>Επισκέπτου την πλατφόρμα</span>
                      <ExternalLink className="w-4 h-4" />
                    </a>
                  </div>
                </div>
                
                {/* Subtle gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/10 via-transparent to-transparent rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewProjectsSection;
